import { awOutboundOperation } from '../../AWIntegrations/AWOutboundOperation';
import type { AWOutboundOperation } from '../../AWIntegrations/types';

export interface ContactResponse {
  admin?: boolean;
  contactType?: string;
  disabled?: boolean;
  email?: string;
  firmId?: string;
  firstName?: string;
  id?: string;
  lastName?: string;
  longShortScope?: boolean;
  phone?: string;
  role?: string;
  scope?: string;
  status?: string;
  teamId?: string;
}

const GET_USER_ATTRIBUTES_PAYLOAD_TYPE = 'mma.getUserAttributes';

export async function getCurrentUserContact(login: string, pkg: string): Promise<object | undefined> {
  const requestBody: AWOutboundOperation = {
    metadata: {
      aladdinUserId: { stringValue: login },
    },
    payload: {},
    payloadType: GET_USER_ATTRIBUTES_PAYLOAD_TYPE,
    pkg,
  };

  const response = await awOutboundOperation(requestBody);
  return response?.data?.payload;
}
